module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/show-code/show-code.component.scss
// module id = ./src/app/show-code/show-code.component.scss
// module chunks = main